import React from 'react';
import { TextField } from '@material-ui/core';

export default props => {
  return (
    <TextField
      margin="normal"
      {...props}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Form/TextField.jsx